import { render, staticRenderFns } from "./LocationInfoAppendix.vue?vue&type=template&id=7481045c"
import script from "./LocationInfoAppendix.vue?vue&type=script&lang=js"
export * from "./LocationInfoAppendix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports